// extracted by mini-css-extract-plugin
export default {"tabs":"LeadsHeader-module-e5ff39bc645158d76ee3","button":"LeadsHeader-module-ecb72eff4075c8f8b5e8"};